// Mount window vs visual peek: ITEMS_AHEAD/BEHIND decide how many
// neighbors stay mounted (so the next swap already has a DOM node).
// MAX_DEPTH is only the painted stack — cards deeper than 1 are in
// the window but look the same as depth 1.
export const ITEMS_BEHIND = 1
export const ITEMS_AHEAD = 5
export const MAX_DEPTH = 1
